import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z"
}), 'ChevronLeftSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ChevronLeftSharp.js
// module id = 2781
// module chunks = 2